// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"eba78efe","185":"d355093b","361":"1302080f","418":"08879d37","574":"d9deba26","788":"ef147f6c","881":"d5168abb","919":"61826ef4"}[chunkId] + ".chunk.css";
};